import React from 'react';
import { Divider } from '@material-ui/core';
import { Breadcrumb } from 'components';
import ButtonLikeTabs from 'components/common/ButtonLikeTabs/ButtonLikeTabs';
import LoadButton from 'components/common/LoadButton/LoadButton';

import './Setting.scss';

const AccountConfirm = () => {
  return (
    <div id="AccountConfirm" className="pb-24 px-8 bg-default">
      <div className="breadcrumb">
        <Breadcrumb routeSegments={[{ name: '設定メニュー', path: '/setting/account' },
        { name: 'アカウント発行', path: '/setting/createAccount' }, { name: 'アカウント確認' }]} />
      </div>

      <h2>アカウント確認</h2>
      <Divider style={{ backgroundColor: "#777", marginBottom: 20 }} className="topDivider" />

      <ButtonLikeTabs text1="発行" text2="発行先一覧" disabled={'text1'}
        link="/setting/account-all" />

      <h1 style={{ justifyContent: 'center', display: 'flex', marginBottom: 30 }}>以下のアカウント発行が完了しました。</h1>
      <Divider style={{ backgroundColor: "#777", marginBottom: 20 }} className="topDivider" />

      <div className="flexDiv">
        <div className="label">発行先名</div>
        <div className="text">株式会社カラーズ</div>
      </div>

      <div className="flexDiv">
        <div className="label">ユーザーID</div>
        <div className="text">colors</div>
      </div>

      <div className="flexBetween" >
        <div className="flexDiv">
          <div className="label">パスワード</div>
          <div className="text">8w2868a2</div>
        </div>
        {/* TODO　何をコピー */}
        <LoadButton text="コピーする" style={{ height: 35 }} onClick={() => { }} />
      </div>

      <Divider style={{ backgroundColor: "#777", marginBottom: 20 }} className="topDivider" />

      <h3>以下のコンテンツを許可しています。</h3>

      <div className="text">HOME</div>
      <div className="text">店舗検索</div>
      <div className="text">売上</div>
      <div className="text">店舗分析</div>
      <div className="text">・売上比較</div>
      <div className="text">・非既存店・既存店分析</div>
      <div className="text">メニュー売上分析</div>
      <div className="text">・オーダー率ランキング</div>
      <div className="text">・部門別ABC表</div>
      <div className="text">・ABC表</div>
      <div className="text">・ﾒﾆｭｰ別点数ﾗﾝｷﾝｸﾞ[日別]</div>
      <div className="text">・店舗別メニュー別構成比</div>
      <div className="text">仕入明細</div>
      <div className="text">・仕入明細表</div>
      <div className="text">・店舗仕入実績</div>
      <div className="text">・月別業態地区別仕入数量</div>
      <div className="text">・店舗別食材売上推移（月次）</div>
      <div className="text">・食材売上額・生餃子出荷数前年比（店・月別）</div>
      <div className="text">・食材売上検証</div>
      <div className="text">営業日報</div>
      <div className="text">・入力</div>
      <div className="text">・閲覧</div>

    </div>
  );
};

export default AccountConfirm;
